/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pin_MessageInputs */

const en_pin_message = /** @type {(inputs: Pin_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pin Message`)
};

const es_pin_message = /** @type {(inputs: Pin_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fijar Mensaje`)
};

const fr_pin_message = /** @type {(inputs: Pin_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Épingler le message`)
};

const de_pin_message = /** @type {(inputs: Pin_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachricht anpinnen`)
};

const id_pin_message = /** @type {(inputs: Pin_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sematkan Pesan`)
};

/** @type {(inputs: Pin_MessageInputs) => LocalizedString} */
const ja_pin_message = en_pin_message;

/** @type {(inputs: Pin_MessageInputs) => LocalizedString} */
const zh_pin_message = en_pin_message;

/** @type {(inputs: Pin_MessageInputs) => LocalizedString} */
const ar_pin_message = en_pin_message;

/** @type {(inputs: Pin_MessageInputs) => LocalizedString} */
const it_pin_message = en_pin_message;

/** @type {(inputs: Pin_MessageInputs) => LocalizedString} */
const ru_pin_message = en_pin_message;

/** @type {(inputs: Pin_MessageInputs) => LocalizedString} */
const pt_pin_message = en_pin_message;

/** @type {(inputs: Pin_MessageInputs) => LocalizedString} */
const ko_pin_message = en_pin_message;

/**
* | output |
* | --- |
* | "Pin Message" |
*
* @param {Pin_MessageInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pin_message = /** @type {((inputs?: Pin_MessageInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pin_MessageInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pin_message(inputs)
	if (locale === "es") return es_pin_message(inputs)
	if (locale === "fr") return fr_pin_message(inputs)
	if (locale === "de") return de_pin_message(inputs)
	if (locale === "ja") return ja_pin_message(inputs)
	if (locale === "zh") return zh_pin_message(inputs)
	if (locale === "ar") return ar_pin_message(inputs)
	if (locale === "id") return id_pin_message(inputs)
	if (locale === "it") return it_pin_message(inputs)
	if (locale === "ru") return ru_pin_message(inputs)
	if (locale === "pt") return pt_pin_message(inputs)
	return ko_pin_message(inputs)
});